import { css } from "@emotion/react";

import { BUTTON_SIZES, SideIconButtonProps } from "./types";

const IconLeftButton = ({ title, icon, size }: SideIconButtonProps) => {
    return (
        <>
            <span
                css={css({
                    display: "flex",
                    alignItems: "center",
                    marginRight: size === BUTTON_SIZES.Tiny ? "4px" : "8px"
                })}
            >
                {icon}
            </span>

            {title}
        </>
    );
};

export default IconLeftButton;
